import React, { Fragment, useState } from "react";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import FormHelperText from "@material-ui/core/FormHelperText";

export const passwordRenderer = (
    value,
    name,
    fieldUpdateHandler,
    isError,
    mutable,
) => {
    const [showPassword, toggleVisibility] = useState(false);
    return mutable ? (
        <Fragment>
            <Input
                autoComplete="off"
                error={!!isError}
                type={showPassword ? "text" : "password"}
                value={"" || value}
                onChange={(e) => fieldUpdateHandler(name, e.target.value)}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => toggleVisibility(!showPassword)}
                        >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </InputAdornment>
                }
            />
            {isError && <FormHelperText error={true}>{isError}</FormHelperText>}
        </Fragment>
    ) : null;
};
